import { render, staticRenderFns } from "./CMakeLogo.vue?vue&type=template&id=d4c24d94&scoped=true&"
import script from "./CMakeLogo.vue?vue&type=script&lang=ts&"
export * from "./CMakeLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c24d94",
  null
  
)

export default component.exports